export default __webpack_public_path__ + "static/media/voiceOverTopBackground.27c24aee.jpg";